import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.object.seal";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import { mapGetters } from 'vuex';
import slug from 'slugify';
export default {
  name: 'CategoryTcVars',
  props: {
    tpl: {
      type: String,
      required: false,
      default: ''
    },
    description: {
      type: Object,
      required: true
    },
    products: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      tcVars: Object.seal({
        env_country: '',
        env_language: '',
        env_template: this.tpl ? this.tpl : 'liste produits',
        user_email: '',
        user_id: '',
        user_category: '',
        user_firstvisit_date: '',
        user_logged: false,
        page_cat1: '',
        page_cat3: '',
        page_number: 1,
        page_url: this.$route.path,
        list_products: [],
        ga_activated: 1,
        is_search_redirection: false,
        redirection_keyword: false,
        mea_category: false,
        earlybirds: '',
        earlybirds_widgets: null,
        search_keywords: null,
        search_results_number: null
      })
    };
  },
  computed: _objectSpread({}, mapGetters({
    user: 'user/me',
    locale: 'i18n/locale'
  })),
  created: function created() {
    var _this = this;

    this.setTcVars('init segmentation');
    this.$root.$on('reset-tcvars', function () {
      _this.setTcVars('segmentation reset tcVars');
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.$root.$off('reset-tcvars');
  },
  methods: {
    tcVarsProducts: function tcVarsProducts() {
      this.tcVars.page_number = this.products.length < 40 ? 1 : Math.floor(this.products.length / 40);
      this.tcVars.list_products = this.products.filter(function (p) {
        return !p.old;
      }).reduce(function (acc, p, idx) {
        acc.push({
          list_product_id: p.reference,
          list_product_position: idx + 1
        });
        return acc;
      }, []);
    },
    setTcVars: function setTcVars(message) {
      if (this.products) {
        this.tcVarsProducts();
      }

      this.tcVars.env_country = this.locale.market;
      this.tcVars.env_language = this.locale.language;
      this.tcVars.user_logged = Boolean(this.user);

      if (this.user && process.client) {
        this.tcVars.user_email = window.localStorage.getItem('MDM_MAIL') || '';
        this.tcVars.user_id = this.user.id;
        this.tcVars.user_category = this.$cookies.get('MDM[statut]') || this.user.type || '';
        this.tcVars.user_firstvisit_date = this.$cookies.get('MDM[date_first_visit]');
      }

      if (this.description.breadcrumb) {
        if (this.description.breadcrumb.length > 1) {
          this.tcVars.page_cat1 = this.description.breadcrumb[1].title;
        }

        this.tcVars.page_cat3 = this.description.breadcrumb.slice(-1)[0].title;
      }

      if (process.client && window.ga === undefined) {
        this.tcVars.ga_activated = 0;
      }

      if ('s' in this.$route.query) {
        this.tcVars.is_search_redirection = true;
        this.tcVars.redirection_keyword = this.$route.query.s;
      }

      if (this.description.commercial && this.description.commercial.mea_banner.url) {
        this.tcVars.mea_category = true;
      } else {
        this.tcVars.mea_category = false;
      }

      if (process.client) {
        try {
          var widgetId = this.description.earlybirdsWidgets ? this.description.earlybirdsWidgets.widgetId : null;
          var earlybirdsWidgets = JSON.parse(localStorage.getItem('EARLYBIRDS_WIDGETS')) || {};

          if (widgetId) {
            Object.assign(earlybirdsWidgets, _defineProperty({}, widgetId, this.description.earlybirdsWidgets));
            localStorage.setItem('EARLYBIRDS_WIDGETS', JSON.stringify(earlybirdsWidgets));
            this.tcVars.earlybirds = widgetId;
            this.tcVars.earlybirds_widgets = earlybirdsWidgets;
          }
        } catch (error) {
          if (this.$sentry) {
            this.$sentry.captureMessage(error);
          }
        }
      }

      if (this.tpl === 'listproduct_keyword' && 'query' in this.description) {
        this.tcVars.search_keywords = slug(this.description.query || '');
        var checkResultSearch = "".concat(this.description.total) === 'undefined' ? 0 : "".concat(this.description.total);
        this.tcVars.search_results_number = checkResultSearch;
      }

      if (process.client && this.$cookies.get('debugmdm')) {
        console.log(message, _objectSpread({}, this.tcVars));
      }

      this.$root.$emit('updated-tcvars', this.tcVars);
    }
  },
  render: function render(h) {
    return h(null);
  }
};